import GroupsIcon from "@mui/icons-material/Groups";
import React from "react";
import styled from "styled-components";
import { Button, Stack } from "@mui/material";
import { useTeams } from "src/scenes/teams/teams-provider";
import { ToastContext } from "src/components/providers/toast-provider";
import request from "../../utils/request";
import useTeamAction from "./hooks/use-team-action";

const TeamCardStyled = styled(Button)`
    height: 172px;
    width: 225px;
    border-radius: 6px;
    background-color: ${({ theme }) => theme.palette.background.default};
    border: ${({ theme }) => `3px dashed ${theme.palette.background.paper}`};
    color: ${({ theme }) => theme.palette.text.secondary};
    cursor: pointer;
`;

const TeamCardTitle = styled.h3`
    font-size: 14px;
    font-weight: normal;
    margin: 0;
    padding: 0;
`;

const TeamCardEmpty = () => {
    const { setMessage, setSeverity, setIsToastTriggered, setNewTeamId } =
        React.useContext(ToastContext);
    const teamsApi = useTeams();

    const createNewTeamAction = useTeamAction(
        async () => {
            const newTeam = await request(`/api/teams/new`, { method: "GET" });
            setMessage(`Team ${newTeam.name} successfully created.`);
            setSeverity("success");
            setNewTeamId(`${newTeam.id}`);
            setIsToastTriggered(true);
            teamsApi.refetch();
        },
        () => {
            setMessage(`You can not perform this action on demo mode`);
            setSeverity("warning");
            setIsToastTriggered(true);
        }
    );

    const handleSubmit = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        setIsToastTriggered(false);
        try {
            createNewTeamAction();
        } catch (error) {
            setMessage(`Failed to create team`);
            setSeverity("error");
            setIsToastTriggered(true);
        }
    };

    return (
        <TeamCardStyled onClick={handleSubmit}>
            <Stack direction="column" alignItems="center" justifyContent="center">
                <GroupsIcon fontSize="large" />
                <TeamCardTitle>Create Team</TeamCardTitle>
            </Stack>
        </TeamCardStyled>
    );
};

export default TeamCardEmpty;
